import { useContext, useState, useEffect } from "react";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";

export const TitlePopup = () => {
  const [store] = useContext(StoreContext);
  const { dimensions, titlepopup, scrollTop } = store;
  const [popupStyle, setPopupStyle] = useState();
  const grefs = useContext(GlobalRefContext);


  useEffect(() => {
    if (titlepopup.label && titlepopup.label in grefs.titlePositions.current) {
      const popupstyle = {
        position: "absolute",
        top:
          grefs.titlePositions.current[titlepopup.label].top + 30 - scrollTop,
        border: "1px solid black",
        padding: 10,
        // minWidth: grefs.titlePositions.current[titlepopup.label].width,
        display: "flex",
        left: grefs.titlePositions.current[titlepopup.label].left,
        backgroundColor: "#ffffff",
        borderRadius: 10,
        color: "#000000",
        fontSize: 14,
        fontWeight: 600,
        zIndex: 999999,
        pointerEvents: "none",
        marginRight: 40,
        maxWidth: "40%",
      };
      setPopupStyle(popupstyle);
    }
  }, [titlepopup, dimensions, scrollTop, grefs.titlePositions]);

  if (titlepopup.active && popupStyle) {
    
    return <div style={popupStyle}>{titlepopup.title}</div>;
  } else return null;
};
